module.exports = __webpack_public_path__ + "static/media/partner_yidong.d1cf67b7.png";